import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import Layout from "app/layout/Layout";
import colors from "app/styles/colors";
import BreadCrumbs from "app/components/Breadcrumbs/Breadcrumbs";
import TextEditor from "../../components/Editors/TextEditor";
import ImageEditor from "../../components/Editors/ImageEditor";
import {
  ChromeReaderMode,
  DeleteTwoTone,
  EditTwoTone,
  ExpandMore,
} from "@mui/icons-material";
import AddLogisticsCard from "app/components/Dialog/AddLogisticsCard";
import { useNavigate } from "react-router-dom";
import { SecondaryButton } from "app/components/Buttons/Button";
import GeneralServices from "app/apis/General/GeneralServices";
import IndustryWeMoveServices from "app/apis/IndustryWeMove/IndustryWeMoveServices";
import { LoadingCircle } from "app/components/UI/Loader";
import { ErrorToaster, SuccessToaster } from "app/components/Toaster/Toaster";
import AddIndustryItem from "app/components/Dialog/AddIndustryItem";

function IndustryWeMove() {
  const navigate = useNavigate();
  const [showDialog, setShowDialog] = useState(false);
  const [toggleStatus, setToggleStatus] = useState(false);
  const [loader, setLoader] = useState(true);
  const [mainBanner, setMainBanner] = useState("");
  const [mainContent, setMainContent] = useState({});
  const [industryItems, setIndustryItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});

  const submitBanner = async (route, data, oldData) => {
    try {
      let formData = new FormData();
      {
        oldData?.id && formData.append("id", oldData?.id);
      }
      formData.append("image", data, data?.name);
      let result = "";
      if (oldData) {
        result = await GeneralServices.updateBanner(route, formData);
      } else {
        result = await GeneralServices.createBanner(route, formData);
      }
      SuccessToaster(result?.message);
      setLoader(true);
    } catch (error) {
      ErrorToaster(error);
      console.log("🚀 ~ submitBanner ~ error:", error);
    }
  };

  const handleMainContent = async (data) => {
    try {
      let formData = new FormData();
      {
        mainContent?.id && formData.append("id", mainContent?.id);
      }
      formData.append("description", data.description);
      let result = "";
      if (mainContent?.id) {
        result = await IndustryWeMoveServices.updateMainText(formData);
      } else {
        result = await IndustryWeMoveServices.createMainText(formData);
      }
      SuccessToaster(result?.message);
      setLoader(true);
    } catch (error) {
      console.log("🚀 ~ handleMainContent ~ error:", error);
    }
  };

  const handleDeleteItem = async (itemId) => {
    try {
      await IndustryWeMoveServices.deleteIndustryItem({ id: itemId });
    } catch (error) {
      console.log("🚀 ~ handleDeleteItem ~ error:", error);
    } finally {
      setLoader(true);
    }
  };
  // get apis ===========
  const getAllData = async () => {
    try {
      let result = await GeneralServices.getBanner("IndustryBanner");
      let result1 = await IndustryWeMoveServices.getMainText();
      let result2 = await IndustryWeMoveServices.getIndustryItem();
      setMainBanner(result?.data[0]);
      setMainContent(result1?.data[0]);
      setIndustryItems(result2?.data);
    } catch (error) {
      console.log("🚀 ~ getAllImages ~ error:", error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (loader) {
      getAllData();
    }
  }, [loader]);

  return (
    <Layout>
      <AddIndustryItem
        showTitle
        handleClose={() => {
          setShowDialog(false);
          setSelectedItem({});
        }}
        open={showDialog}
        characterLimit={110}
        toggle={toggleStatus}
        selectedData={selectedItem}
        reload={() => setLoader(true)}
      />
      <Box
        sx={{ backgroundColor: colors.lightGray, p: 3, borderRadius: "12px" }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ bgcolor: colors.white, p: 2, borderRadius: "12px" }}
        >
          <Grid item xs={6}>
            <Typography variant="body1" fontWeight="bold" color="initial">
              Industry We Move Management
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage="Industry We Move Management" />
          </Grid>
        </Grid>
        {loader ? (
          <LoadingCircle />
        ) : (
          <Box sx={{ mt: 2 }}>
            <ImageEditor
              title={"Banner Image"}
              handleData={(e) => submitBanner("IndustryBanner", e, mainBanner)}
              uploadedImage={mainBanner}
            />
            <TextEditor
              title="Main Text"
              characterLimit={1550}
              data={mainContent}
              handleData={(e) => handleMainContent(e)}
            />
            {/* ============Table============ */}
            <Accordion
              sx={{
                mb: 1,
                boxShadow: "none",
                "&::before": {
                  display: "none",
                },
              }}
            >
              <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography variant="body1" fontWeight="bold" color="initial">
                  Industry We Move Items
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    p: 2,
                  }}
                >
                  <SecondaryButton
                    onClick={() => {
                      setShowDialog(true);
                      setToggleStatus(true);
                    }}
                    title="Add Item"
                  />
                </Box>
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow sx={{ bgcolor: colors.primary }}>
                        <TableCell
                          sx={{ fontWeight: "bold", color: colors.white }}
                        >
                          Image
                        </TableCell>
                        <TableCell
                          sx={{ fontWeight: "bold", color: colors.white }}
                        >
                          Title
                        </TableCell>
                        <TableCell
                          sx={{ fontWeight: "bold", color: colors.white }}
                        >
                          Action
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {industryItems?.map((row) => (
                        <TableRow
                          key={row.name}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell component="th" scope="row">
                            <Typography
                              component={"img"}
                              sx={{
                                width: 70,
                                height: 70,
                                objectFit: "contain",
                                borderRadius: 70,
                              }}
                              src={row?.image}
                            />
                          </TableCell>
                          <TableCell component="th" scope="row">
                            {row.title}
                          </TableCell>
                          <TableCell>
                            <IconButton
                              onClick={() => {
                                setSelectedItem(row);
                                setShowDialog(true);
                                setToggleStatus(false);
                              }}
                            >
                              <EditTwoTone color="primary" />
                            </IconButton>
                            <IconButton
                              onClick={() =>
                                navigate(`/industries-we-move/${row?.id}`)
                              }
                            >
                              <ChromeReaderMode color="info" />
                            </IconButton>
                            <IconButton
                              onClick={() => handleDeleteItem(row?.id)}
                            >
                              <DeleteTwoTone color="error" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </AccordionDetails>
            </Accordion>
          </Box>
        )}
      </Box>
    </Layout>
  );
}

export default IndustryWeMove;
